// @ts-nocheck
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const ClearForm: Handler = props => {
    props.dispatch({
        type: "Greif/Pages/TECNotification/ClearForm",
    });
};

export const chain = [ClearForm];

const clearTECNotificationForm = createHandlerChainRunnerOptionalParameter(chain, {}, "ClearForm");
export default clearTECNotificationForm;
